import { render } from "./ProductStockPage.vue?vue&type=template&id=64ddd7bb&scoped=true"
import script from "./ProductStockPage.vue?vue&type=script&lang=js"
export * from "./ProductStockPage.vue?vue&type=script&lang=js"

import "./ProductStockPage.vue?vue&type=style&index=0&id=64ddd7bb&scoped=true&lang=css"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ddd7bb"]])

export default __exports__